import { DEFAULT_CONTAINER_WIDTH, DEFAULT_BREAKPOINTS, DEFAULT_SPACING } from './constants';
export const getBreakpointForScreenWidth = (breakpoints, screenWidth)=>breakpoints.slice().reverse().find((point)=>screenWidth >= point.maxWidth) || breakpoints[0];
export const getGridConfiguration = ({ breakpoints =DEFAULT_BREAKPOINTS , containerWidth =DEFAULT_CONTAINER_WIDTH , screenWidth =DEFAULT_CONTAINER_WIDTH , elementSpacing =DEFAULT_SPACING , dontScale =false  })=>{
    const { elementWidth , elementHeight , elementsPerRow: elementsPerRowConfig  } = getBreakpointForScreenWidth(breakpoints, screenWidth);
    // We try to place X elements per row such that width of elements is as close
    // to targetWidth as possible, but not greater
    const elementsPerRow = elementsPerRowConfig !== null && elementsPerRowConfig !== void 0 ? elementsPerRowConfig : Math.max(1, Math.floor((containerWidth + elementSpacing) / (elementWidth + elementSpacing)));
    if (dontScale) {
        return {
            elementWidth,
            elementHeight,
            elementSpacing,
            elementsPerRow
        };
    }
    const ratio = elementHeight ? elementWidth / elementHeight : 0;
    const adjustedElementWidth = (containerWidth + elementSpacing) / elementsPerRow - elementSpacing;
    const adjustedElementHeight = adjustedElementWidth / ratio;
    return {
        elementWidth: adjustedElementWidth,
        elementHeight: adjustedElementHeight,
        elementSpacing,
        elementsPerRow
    };
};
